import React from 'react'
import { useCallback } from 'sb-hooks'
import { connect } from 'redaction'
import actions from 'redux/actions'

import HeaderHeight from 'layouts/InsideLayout/Header/HeaderHeight/HeaderHeight'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './Header.scss'


const CartOverlayHeader = ({ totalCount }) => {
  const handleClick = useCallback(() => actions.models.cart.close(), [])

  const title = totalCount ? messages.itemsInCart : messages.yourCart

  return (
    <HeaderHeight className={s.header}>
      <CloseIcon className={s.closeButton} onClick={handleClick} />
      <Text
        className={s.totalCount}
        message={title}
        values={{ count: totalCount }}
        align="center"
        html
      />
    </HeaderHeight>
  )
}


export default connect({
  totalCount: 'models.cart.totalCount',
})(CartOverlayHeader)
